import "./index.css"
import NavbarBoot from "../Navbar"
function Header(){
    return(
        <div className="headerDiv" > 
            <NavbarBoot/>
        </div>
    )
}

export default Header